<template>
  <div class="widget-content">
    <div class="panel-body">
      <div class="parent ex-1">
        <VueDraggableNext :list="this.modules" :disabled="true">
          <div v-for="section in modules" :key="section.label" class="mb-4">
            <h5 class="mb-3">{{ section.label }}</h5>
            <div
              v-for="item in section.items"
              :key="item.code"
              :class="'d-md-flex d-block text-sm-start text-center item'"
            >
              <div class="media-body">
                <div class="d-flex justify-content-between align-items-center flex-column flex-md-row gap-5">
                  <div class="item__heading" style="flex: 1; min-width: 0">
                    <span :class="'dot bg-' + (item.enable ? 'success' : 'danger')"></span>
                    <div class="item__title">
                      {{ item.description }}
                    </div>
                  </div>
                  <div class="d-flex gap-3 flex-shrink-0 align-items-center">
                    <button
                      class="btn btn-icon btn-group"
                      v-tooltip="{ title: $t(item.code) }"
                      @click="copyCode(item.code)"
                      aria-label="Copier le code"
                    >
                      <FontAwesomeIcon :icon="'fa-copy'" />
                    </button>
                    <div class="item__heading" style="min-width: 250px">
                      <FontAwesomeIcon v-if="item.icon" :icon="'fa-light fa-' + item.icon" class="item__icon" />
                      <div class="item__title">
                        {{ item.code }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </VueDraggableNext>
      </div>
    </div>
  </div>
</template>

<script>
import { notificationManager } from "@/services/utilities/notification-manager";
import { VueDraggableNext } from "vue-draggable-next";

export default {
  name: "TemplateVariableComponent",
  components: {
    VueDraggableNext,
  },
  props: {
    modules: {
      type: Array,
      required: true,
    },
  },
  methods: {
    copyCode(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          notificationManager.showNotification(
            "success",
            this.$tc("admin.copy.success", 2, {
              name: this.$t("admin.variable.title"),
            }),
          );
        })
        .catch((err) => {
          console.error("Erreur lors de la copie :", err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  padding: 5px 25px;
  border: 1px solid $grey;
  border-radius: $radius;
  min-height: 50px;
  align-items: center;
  margin-bottom: 10px;

  @include dark-theme {
    background: $m-color_9;
  }

  @include up-to-md {
    padding: 15px;
  }

  &__heading {
    display: flex;
    align-items: center;
  }

  &__title {
    font-size: 16px;
    color: $admin-color;

    @include mobile {
      max-width: 195px;
      overflow: hidden;
      -ms-text-overflow: ellipsis;
      text-overflow: ellipsis;
    }

    @include dark-theme {
      color: $white;
    }
  }

  &__icon {
    margin-right: 15px;
    font-size: 22px;

    @include up-to-md {
      margin-right: 10px;
      font-size: 18px;
    }
  }
}

.widget-content {
  min-height: 200px;
  position: relative;
}
</style>
